<template>
  <div>
    <div class="d-flex align-items-center">
      <h1 class="h3">
        {{ $t('productAvailability.goodsReceipt') }}
      </h1>
      <div class="ml-auto">
        <a-button
          v-if="params.warehouse_id && permission.includes('WRITE') && !flagWms"
          type="primary"
          size="large"
          @click="openModal(true)"
        >
          <a-icon type="plus-square" />
          {{ $t('productAvailability.createGr') }}
        </a-button>
        <a-button
          v-if="params.warehouse_id && permission.includes('WRITE') && !flagWms"
          type="primary"
          size="large"
          class="ml-3"
          @click="toggleModalImport(true)"
        >
          <a-icon type="plus-square" />
          {{ $t('productAvailability.importGr') }}
        </a-button>
      </div>
    </div>
    <a-row :gutter="24" class="mt-4">
      <a-col v-if="!isWarehouseUser" :span="9">
        <a-select
          v-model="params.warehouse_id"
          :placeholder="$t('productAvailability.gudang')"
          class="select-antd-default"
          size="large"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          :allow-clear="warehouseList.length > 1"
          :disabled="loading || isLoading"
          @change="handleChangeWarehouse"
        >
          <a-select-option
            v-for="item in warehouseList"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <a-alert
          v-if="!params.warehouse_id"
          class="mt-2"
          style="font-size: 13px"
          :message="$t('productAvailability.warningGr')"
          type="warning"
          show-icon
        />
      </a-col>
      <a-col :span="isWarehouseUser ? 18 : 9">
        <a-input-search
          v-model="params.query"
          size="large"
          :placeholder="$t('utils.search')"
          :loading="loading || isLoading"
          :disabled="loading || isLoading"
          allow-clear
          @search="handleSearch"
        >
          <a-button slot="enterButton" type="danger" icon="search">
            {{ $t('utils.search') }}
          </a-button>
        </a-input-search>
      </a-col>
    </a-row>
    <div class="mt-4">
      <a-table
        class="gr-list"
        :data-source="products"
        :row-key="record => record.id"
        :columns="columns"
        :loading="loading || isLoading"
        :pagination="false"
        :scroll="scroll"
      >
        <template slot="number" slot-scope="text">
          <a-tooltip placement="topRight">
            <template #title>
              <span>{{ text }}</span>
            </template>
            {{ text }}
          </a-tooltip>
        </template>
        <template slot="date" slot-scope="text">
          {{ $moment(text).format('HH:mm:ss, DD MMM YYYY') }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a-dropdown placement="bottomRight">
            <a @click.prevent="">
              <a-icon type="more" />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item
                  key="1"
                  class="py-2"
                >
                  <RouterLink
                    :to="{ name: 'inventory.goods.receipt.detail', params: { id: record.id }, query: { ...$route.query, number_gr: record.number, number_inbound: record.inbound_reference } }"
                  >
                    <a-icon type="info-circle" class="mr-1" />
                    {{ $t('productAvailability.detailGr') }}
                  </RouterLink>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
    </div>
    <div class="mt-4 text-right">
      <a-pagination
        v-model="params.page"
        :page-size="params.size"
        :page-size-options="sizeOptions"
        :total="total_row"
        :show-total="(total, range) => $t('utils.pagination_show_total', { perpage: `${range[0]} - ${range[1]}`, total })"
        :locale="{ items_per_page: $t('utils.items_per_page') }"
        :disabled="loading || isLoading"
        show-size-changer
        @change="handlePageChange"
        @showSizeChange="handleShowSizeChange"
      />
    </div>

    <a-modal
      v-model="showModalImport"
      :width="380"
      :closable="false"
      :dialog-style="{ top: '20px' }"
      :title="$t('productAvailability.importGr')"
      class="dialog-gr"
    >
      <template slot="footer">
        <a-button
          key="back"
          :disabled="downloading || uploading"
          @click="fileList = []; toggleModalImport(false)"
        >
          {{ $t('utils.close') }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="uploading"
          :disabled="fileList.length < 1 || downloading || uploading"
          @click="handleUpload"
        >
          {{ $t('utils.save') }}
        </a-button>
      </template>
      <p class="mb-2">
        {{ $t('productAvailability.bulkImportGrDesc') }}
      </p>
      <div class="mb-2">
        <p class="mb-1">
          <b>{{ $t('utils.step', { step: 1 }) }}</b>
        </p>
        <button
          class="avatar-uploader ant-upload-picture-card-wrapper btn-download"
          :disabled="downloading || uploading"
          @click="downloadTemplate"
        >
          <div class="ant-upload ant-upload-select ant-upload-select-picture-card">
            <span role="button" tabindex="0" class="ant-upload">
              <div>
                <a-icon type="download" class="mr-1" />
                {{ $t('utils.downloadTemplate') }}
              </div>
            </span>
          </div>
        </button>
      </div>
      <div>
        <p class="mb-1">
          <b>{{ $t('utils.step', { step: 2 }) }}</b>
        </p>
        <a-spin :spinning="uploading">
          <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            :disabled="downloading || uploading"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
            <div v-if="fileList.length < 1">
              <a-icon :type="uploading ? 'loading' : 'upload'" class="mr-1" />
              {{ $t('productAvailability.uploadBulkGr') }}
            </div>
          </a-upload>
        </a-spin>
      </div>
      <a-alert
        v-if="importFile.show"
        type="info"
        class="alert-import mt-2"
      >
        <div slot="description" class="summary-import">
          <p style="margin-bottom: 4px; font-size: 14px; font-size: 13px; font-weight: bold;">
            <a-icon type="info-circle" theme="twoTone" /> {{ $t('productAvailability.bulkGrSummary') }}
          </p>
          <a-row :gutter="16">
            <a-col span="12">
              {{ $t('utils.successData') }}
            </a-col>
            <a-col span="12">
              : <b class="text-success">{{ importFile.success }}</b>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col span="12">
              {{ $t('utils.failedData') }}
            </a-col>
            <a-col span="12">
              : <b class="text-danger">{{ importFile.failed }}</b>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col span="12">
              {{ $t('utils.totalData') }}
            </a-col>
            <a-col span="12">
              : <b>{{ importFile.total }}</b>
            </a-col>
          </a-row>
          <div v-if="importFile.errors && importFile.errors.length" class="mt-2">
            <b>
              <a href="#" style="font-size: 13px; color: #1890ff !important" @click="downloadFailedTemplate(importFile.request_id)">{{ $t('productAvailability.downloadFailedData') }}</a>
            </b>
          </div>
        </div>
      </a-alert>
    </a-modal>

    <ModalCreateGR
      :show-modal="visibleModal"
      :loading="loading || isLoading"
      :warehouse="params.warehouse_id"
      @handleModal="openModal"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  getGoodsReceipt,
  getBulkGoodsReceiptProcess,
  downloadBulkGoodsReceiptTemplate,
  downloadFailedBulkGoodsReceipt,
  uploadBulkGoodsReceipt,
} from '@/api/good-receive'
import { getWarehouseInternal } from '@/api/warehouse'
import { RouterLink } from 'vue-router'

export default {
  components: {
    ModalCreateGR: () => import(/* webpackPrefetch: true */ './component/ModalCreateGR.vue'),
  },
  data: function () {
    return {
      screenHeight: 'calc(100vh - 400px)',
      total_row: 0,
      loading: false,
      isLoading: false,
      visibleModal: false,
      flagWms: false,
      showModalImport: false,
      downloading: false,
      uploading: false,
      businessList: [],
      warehouseList: [],
      products: [],
      fileList: [],
      sizeOptions: ['10', '20', '30', '40', '50'],
      params: {
        warehouse_id: undefined,
        query: '',
        page: 1,
        size: 10,
      },
      importFile: {
        show: false,
        success: 0,
        failed: 0,
        total: 0,
        errors: null,
        request_id: null,
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('productAvailability.grNumber'),
          key: 'number',
          dataIndex: 'number',
          width: 250,
          ellipsis: true,
          scopedSlots: { customRender: 'number' },
        },
        {
          title: this.$t('productAvailability.vendorName'),
          key: 'supplier_title',
          dataIndex: 'supplier_title',
          ellipsis: true,
        },
        {
          title: this.$t('productAvailability.grDate'),
          key: 'date',
          dataIndex: 'date',
          ellipsis: true,
          scopedSlots: { customRender: 'date' },
        },
        {
          title: this.$t('productAvailability.reference'),
          key: 'reference_number',
          dataIndex: 'reference_number',
          ellipsis: true,
        },
        {
          title: '',
          key: 'action',
          dataIndex: 'action',
          width: 50,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    businessId() {
      return (this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id) || ''
    },
    isWarehouseUser() {
      return this.$store.state.user.restriction_base === 'Warehouse'
    },
    scroll() {
      return {
        y: 'calc(100vh - 400px)',
        x: 1000,
      }
    },
    tHeight() {
      return !this.products.length ? '0px' : 'calc(100vh - 400px)'
    },
    permission() {
      return this.$store.getters['user/can']('goods-receipt')
    },
  },
  watch: {
    businessId() {
      this.init()
    },
    '$route.query'() {
      this.getWarehouseList()
    },
  },
  created() {
    this.init()
  },
  methods: {
    openModal(param) {
      this.visibleModal = param
    },
    init: debounce(async function() {
      this.loading = true
      try {
        // getBusinessList & getWarehouseList can run in parallel
        const [businessResult, warehouseResult] = await Promise.all([
          this.getBusinessList(),
          this.getWarehouseList(),
        ])
        this.businessList = businessResult
        this.warehouseList = warehouseResult

        // getInventoryList must wait for warehouse_id to be set first
        const inventoryResult = await this.getInventoryList()
        this.products = inventoryResult

        const filter = this.warehouseList.filter(v => {return v.value === this.params.warehouse_id})
        this.flagWms = filter?.[0]?.wms_code === null || filter?.[0]?.wms_code?.toUpperCase() === 'N/A' || filter?.[0]?.wms_code === '' ? false : true
      } catch (err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    }, 500),
    async getWarehouseList() {
      return await getWarehouseInternal({
        business_id: this.businessId,
        limit: 500,
      })
        .then(res => {
          const raw = res?.data?.data || res?.data || []
          const response = raw.map(w => ({
            ...w,
            value: String(w.id || w.warehouse_id),
            label: String(w.name || w.warehouse_name || '').trim(),
          }))

          this.params.warehouse_id = this.$store.state.user.restriction_base === 'Warehouse'
            ? this.$route.query.warehouse_id || this.$route.query.warehouseId
            : this.$store.state.user.restriction_base !== 'Warehouse' && response.length === 1
            ? response[0].value
            : this.$route.query.warehouse_id || this.$route.query.warehouseId || undefined

          // Auto-select first warehouse if only one exists and not already selected
          if(!this.params.warehouse_id && response.length === 1) {
            this.params.warehouse_id = response[0].value
            this.$router.push({
              query: { ...this.$route.query, warehouseId: response[0].value, page: 1 },
            })
          }

          return response
        })
        .catch(err => {
          this.params.warehouse_id = undefined
          console.error(err)
          return []
        })
    },
    async getInventoryList() {
      this.isLoading = true
      return await getGoodsReceipt({
          ...this.params,
          business_id: this.businessId,
        })
        .then(({ data: response }) => {
          this.total_row = response?.total_items || 0
          return response?.data || []
        })
        .catch(err => {
          this.total_row = 0
          console.error(err)
          return []
        })
        .finally(() => this.isLoading = false)
    },
    async getBusinessList() {
      return await this.$store
        .dispatch('business/GETBUSINESS', {
          business_id: this.businessId,
        })
        .then(({ data }) => data)
        .catch(err => {
          console.error(err)
          return []
        })
    },
    async handleChangeWarehouse(value) {
      if(value) {
        const filter = this.warehouseList.filter(warehouse => { return warehouse.value === value })
        this.flagWms = filter?.[0]?.wms_code === null
          || filter?.[0]?.wms_code?.toUpperCase() === 'N/A'
          || filter?.[0]?.wms_code === ''
            ? false
            : true
      }
      this.params.page = 1
      this.$router.push({
        query: { ...this.$route.query, warehouseId: value, page: 1 },
      })
      this.products = await this.getInventoryList()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
      )
    },
    async handleSearch() {
      this.params.page = 1
      this.products = await this.getInventoryList()
    },
    async handlePageChange(pageNumber) {
      this.params.page = pageNumber
      this.products = await this.getInventoryList()
    },
    async handleShowSizeChange(current, pageSize) {
      this.params.page = current
      this.params.size = pageSize
      this.products = await this.getInventoryList()
    },
    getBulkProcess: debounce(async function(request_id) {
      await getBulkGoodsReceiptProcess({
          business_id: this.businessId,
          request_id,
        })
        .then(({ data: response }) => {
          let show = true
          const success = response?.successCount || 0
          const failed = response?.failedCount || 0
          const total = response?.totalRows || 0
          const errors = response?.errors || null
          
          if(['INITIATED', 'VALIDATING', 'PROCESSING'].includes(response.status)) {
            show = false
            this.getBulkProcess(request_id)
          } else if(['COMPLETED', 'PARTIALLY_COMPLETED'].includes(response.status)) {
            this.$notification.success({
              message: 'Upload Berhasil',
              description: 'Data berhasil di upload. Silahkan refresh data secara berkala',
            })
            this.init()
          } else {
            this.$notification.error({
              message: 'Upload Gagal',
              description: 'Data gagal di upload',
            })
          }

          this.importFile = { show, success, failed, total, errors, request_id }
        })
        .catch(err => {
          this.$notification.error({
            message: 'Upload Gagal',
            description: err.response?.data?.message || err.message,
          })
        })
        .finally(() => this.uploading = false)
    }, 1000),
    async downloadTemplate() {
      this.downloading = true
      await downloadBulkGoodsReceiptTemplate(this.businessId)
        .then(res => {
          if (res?.data) {
            const a = document.createElement('a')
            a.href = window.URL.createObjectURL(res.data)
            a.download = 'Bulk_Import_Good_Receive.xlsx'
            document.body.appendChild(a)
            a.click()
            setTimeout(() => {
              a.remove()
            }, 9)
          } else {
            this.$notification.error({
              message: 'Download Gagal',
              description: 'File gagal di download. Data kosong',
            })
          }
        })
        .catch(err => {
          this.$notification.error({
            message: 'Download Gagal',
            description: err.response?.data?.message || err.message,
          })
        })
        .finally(() => this.downloading = false)
    },
    downloadFailedTemplate: debounce(async function(request_id) {
      this.downloading = true
      await downloadFailedBulkGoodsReceipt({
        business_id: this.businessId,
        request_id,
      })
        .then(res => {
          if (res?.data) {
            const a = document.createElement('a')
            a.href = window.URL.createObjectURL(res.data)
            a.download = 'Failed_Bulk_Import_Good_Receive.xlsx'
            document.body.appendChild(a)
            a.click()
            setTimeout(() => {
              a.remove()
            }, 9)
          } else {
            this.$notification.error({
              message: 'Download Gagal',
              description: 'File gagal di download. Data kosong',
            })
          }
        })
        .catch(err => {
          this.$notification.error({
            message: 'Download Gagal',
            description: err.response?.data?.message || err.message,
          })
        })
        .finally(() => this.downloading = false)
    }, 500),
    async handleUpload() {
      this.uploading = true

      await uploadBulkGoodsReceipt({
        business_id: this.businessId,
        file: this.fileList[0],
      })
      .then(({ data: response }) => {
        this.fileList = []
        this.getBulkProcess(response?.processId)
      })
      .catch(err => {
        this.$notification.error({
          message: 'Upload Gagal',
          description: err.response?.data?.message || err.message,
        })
        this.uploading = false
      })
    },
    toggleModalImport(value) {
      this.showModalImport = value
      this.resetImportData()
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.resetImportData()
    },
    beforeUpload(file) {
      this.fileList = [...this.fileList, file]
      this.resetImportData()
      return false
    },
    resetImportData() {
      this.importFile = {
        show: false,
        success: 0,
        failed: 0,
        total: 0,
        errors: null,
        request_id: null,
      }
    },
  },
}
</script>

<style lang="scss">
.select-antd-default.ant-select-lg {
  width: 100%;

  .ant-select-selection__rendered {
    line-height: 38px !important;
  }
}

.alert-import {
  padding: 10px 15px;
}

.summary-import .ant-col {
  font-size: 13px !important;
}

.gr-list div.ant-table-body {
  min-height: v-bind(tHeight);
}

.dialog-gr .ant-modal-body {
  padding: 16px 24px !important;
}

.avatar-uploader > .ant-upload,
.ant-upload-list-picture-card-container,
.ant-upload-list-picture-card .ant-upload-list-item {
  width: 100% !important;
  height: 40px !important;
  margin: 0 !important;
}

.avatar-uploader {
  .ant-upload-select-picture-card {
    i {
      font-size: 14px !important;
      color: #999 !important;
    }

    .ant-upload-text {
      margin-top: 8px !important;
      color: #666 !important;
    }

    .ant-upload-list-item-thumbnail {
      font-size: 48px !important;
    }

    .ant-upload-list-item-actions i {
      width: 24px !important;
      font-size: 24px !important;
    }
  }

  .ant-upload-list-item {
    padding: 0 !important;
  
    &-info {
      border-radius: 2px !important;

      i {
        display: none !important;
      }
    }

    &-name {
      white-space: inherit !important;
    }
  }
}

.btn-download {
  margin: 0;
  padding: 0;
  border: none;

  .ant-upload {
    width: 100% !important;
  }
}

.btn-download:disabled div,
.btn-download[disabled] div,
.btn-download:disabled span,
.btn-download[disabled] span {
  cursor: not-allowed;
}

.gr-list div.ant-table-body {
  max-height: calc(100vh - 400px) !important;
  min-height: auto !important;
}
</style>